import useResponsiveFlags from '../hooks/useResponsiveFlags';
import useLanguage from '../hooks/useLanguage';

import styles from '../assets/styles/Footer.module.css';
import { translations } from '../locales/lang';

export default function Footer() {
    const { isMobile } = useResponsiveFlags();
    const { language } = useLanguage();

    return (
        <footer className={styles.footer}>
            <div className={styles.topSection}>
                <div className={styles.column}>
                    <h4 className={styles.heading}>{translations[language].footer.nameCompany}</h4>
                    <ul className={styles.infoList}>
                        <li className={styles.infoItem} >
                            <img src="/images/footer/address.svg" alt="Trụ sở" className={styles.icon} />
                            {translations[language].footer.title}
                        </li>
                        <li className={styles.infoItem} style={{ marginBottom: isMobile ? '16px' : '24px' }}>
                            <div className={styles.icon} />
                            {translations[language].footer.address}
                        </li>

                        <li className={styles.infoItem} style={{ marginBottom: isMobile ? '16px' : '24px' }}>
                            <img src="/images/footer/web-site.svg" alt="Website" className={styles.icon} />
                            {translations[language].footer.website}
                        </li>
                        <li className={styles.infoItem} style={{ marginBottom: isMobile ? '16px' : '24px' }}>
                            <img src="/images/footer/email.svg" alt="Email" className={styles.icon} />
                            {translations[language].footer.email}
                        </li>
                        <li className={styles.infoItem} >
                            <img src="/images/footer/phone.svg" alt="Tổng đài" className={styles.icon} />
                            {translations[language].footer.hotline}
                        </li>
                        <li className={styles.infoItem} style={{ marginBottom: isMobile ? '16px' : '24px' }}>
                            <div className={styles.icon} />
                            {translations[language].footer.phone}
                        </li>
                        <li className={styles.infoItem} style={{ marginBottom: isMobile ? '16px' : '24px' }}>
                            <img src="/images/footer/tax.svg" alt="tax" className={styles.icon} />
                            {translations[language].footer.tax}
                        </li>
                        <li className={styles.infoItem}>
                            <div className={styles.icon} />
                            {translations[language].footer.copyrightDate}
                            <br />
                            {translations[language].footer.copyrightWarning}
                            <br />
                            {translations[language].footer.copyright}
                        </li>
                    </ul>

                </div>
                <div className={`${styles.column} ${styles.columnRight}`}>
                    <h4 className={styles.heading}>{translations[language].footer.ecosystem}</h4>
                    <div className={styles.containerImage}>
                        <img src="/images/footer/eduhome.svg" alt="eduhome" className={styles.ecosystemLogo} onClick={() => window.open('https://eduhome.com.vn/', '_blank')} />
                        <img src="/images/footer/edufun.svg" alt="edufun" className={styles.ecosystemLogo} onClick={() => window.open('https://edufun.com.vn/', '_blank')} />
                        <img src="/images/footer/i-test.svg" alt="i-test" className={styles.ecosystemLogo} onClick={() => window.open('https://i-test4u.vn/', '_blank')} />
                        <img src="/images/footer/partner.svg" alt="partner" className={styles.ecosystemLogo} onClick={() => window.open('https://dtp-education.com/', '_blank')} />
                    </div>

                    <h4 className={styles.heading}>{translations[language].footer.connectWithUs}</h4>
                    <div className={styles.socialIcons}>
                        <img src="/images/footer/zalo-icon.svg" alt="Zalo" />
                        <img src="/images/footer/facebook-icon.svg" alt="Facebook" />
                        <img src="/images/footer/youtube-icon.svg" alt="YouTube" />
                    </div>
                    {/* <img src="/images/footer/bo-cong-thuong.svg" alt="Đã thông báo bộ công thương" className={styles.verified} /> */}
                </div>
            </div>
            <div className={styles.bottomSection}>
                <hr />
                <p>{translations[language].footer.bottomText}</p>
            </div>
        </footer>
    );
}
